<template>
  <div class="filter-dates">
    <v-menu v-model="menu" :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="label"
          v-bind="attrs"
          v-on="on"
          :label="$t('filters.dates')"
          prepend-inner-icon="mdi-calendar-search-outline"
          class="filter-dates__label"
          hide-details
          readonly
          outlined
          dense
        />
      </template>
      <v-list dense>
        <v-list-item v-for="(date, index) in dateOptions" @click="selectDate(date.title, date.days)" :key="index">
          <div class="body-2">
            {{ $t(`filters.date.${[date.title]}`) }}
          </div>
        </v-list-item>
        <v-divider />
        <FilterDateRange
          @emitDateRange="setDateRange"
          :fetchData="fetchData"
          :startDateProp="startDateProp"
          :endDateProp="endDateProp"
        />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { dateOptions } from './FilterDatesOptions'
import { formatCountryDate } from '@/util/catalog'
import { mapMutations, mapGetters } from 'vuex'

import FilterDateRange from './FilterDateRange'

export default {
  name: 'FilterDatesTimezone',

  components: {
    FilterDateRange
  },

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    startDateProp: {
      type: String,
      default: 'startDate',
    },

    endDateProp: {
      type: String,
      default: 'endDate',
    },
  },

  computed: {
    ...mapGetters(['filters']),
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    resetParams() {
      this.params = { [this.startDateProp]: null, [this.endDateProp]: null }
    },

    resetDateRange() {
      const dateRange = this.$refs?.dateRange
      dateRange && dateRange.resetDateRange()
    },

    setDateLabel(label) {
      this.label = this.$t(`filters.date.${label}`)
    },

    setDateRange(dateRange) {
      const startDate = dateRange?.start && formatCountryDate(dateRange?.start)
      const endDate = dateRange?.end && formatCountryDate(dateRange?.end)

      this.label = `${startDate} ${endDate ? `- ${endDate}` : ''}`
    },

    formatRecent() {
      const todayFirstHour = moment().format('YYYY-MM-DD') + 'T00:00:00'
      const todayLastHour = moment().format('YYYY-MM-DD') + 'T23:59:59'

      const startDate = moment.tz(todayFirstHour, this.timezone).add(-1, 'month').format('YYYY-MM-DDTHH:mm:ssZ')
      const endDate = moment.tz(todayLastHour, this.timezone).add(1, 'month').format('YYYY-MM-DDTHH:mm:ssZ')

      this.params = { [this.startDateProp]: startDate, [this.endDateProp]: endDate }
    },

    formatDate(days) {
      const dateToday = moment().format('YYYY-MM-DDT00:00:00')
      const dateDays = moment().subtract(days, 'days').format('YYYY-MM-DDT23:59:59')
      const startDate = moment.tz(dateDays, this.timezone).format('YYYY-MM-DDTHH:mm:ssZ')
      const endDate = moment.tz(dateToday, this.timezone).format('YYYY-MM-DDTHH:mm:ssZ')

      this.params = { [this.startDateProp]: startDate, [this.endDateProp]: endDate }
    },

    selectDate(title, days) {
      this.menu = false
      this.label = this.$t(`filters.date.${[title]}`)

      if (!days) this.resetParams()
      else title === 'recent' ? this.formatRecent() : this.formatDate(days)

      this.setFilters({ ...this.filters, ...this.params })
      this.setCurrentPage(1)
      this.resetDateRange()
      this.fetchData()
    },
  },

  data() {
    return {
      menu: false,
      label: this.$t('filters.date.recent'),
      timezone: moment.tz.guess(),
      params: {},
      dateOptions,
    }
  }
}
</script>

<style scoped>
.filter-dates__label {
  width: 245px;
}
</style>
